// Reducer
const intitialState = {
    country: 'defaultCountry',
    province: 'defaultProvince',
    city: 'defaultCity',
    street: 'defaultStreet',
    product: 'defaultProduct',
    image: '',
    dateFrom: 'deafaultDateFrom',
    dateTo: 'defautDateTo',
    foe: 'defaultFOE',
    description: 'defaultDesription',
    descriptionError: false,
    longDescription: 'defaultLongDescription',
    commentCon: 'defaultComment',
    commentPlaner: 'defaultComment',
    commentOwner: 'defaultComment',
    title: 'defaultTitle',
    externalRelease: 'false',
    zip: 'defaultZip',
    countryError: false,
    provinceError: false,
    cityError: false,
    zipError: false,
    errorRequiredProd: false,
    imageUploadError: false,
    foeError: false,
    titleError: false,
    contestRelease: 'false',
    latitude: '',
    longitude: '',
    source: '',
    uploadReady: true
}

export default function createRefInfo(state = intitialState, action) {
    switch (action.type) {

        case 'SET_CITY':
            return { ...state, city: action.payload }
        case 'SET_PROVINCE':
            return { ...state, province: action.payload }
        case 'SET_COUNTRY':
            return { ...state, country: action.payload }
        case 'SET_PRODUCT':
            return { ...state, product: action.payload }
        case 'SET_IMAGE':
            return { ...state, image: action.payload }
        case 'SET_DATEFROM':
            return { ...state, dateFrom: action.payload }
        case 'SET_DATETO':
            return { ...state, dateTo: action.payload }
        case 'SET_FOE':
            return { ...state, foe: action.payload }
        case 'SET_DESCRIPTION':
            return { ...state, description: action.payload }
        case 'SET_DESCRIPTION_ERR':
            return { ...state, descriptionError: action.payload }
        case 'SET_LONG_DESCRIPTION':
            return { ...state, longDescription: action.payload }
        case 'SET_COMMENT_CON':
            return { ...state, commentCon: action.payload }
        case 'SET_COMMENT_PLANER':
            return { ...state, commentPlaner: action.payload }
        case 'SET_COMMENT_OWNER':
            return { ...state, commentOwner: action.payload }
        case 'SET_TITLE':
            return { ...state, title: action.payload }
        case 'SET_STREET':
            return { ...state, street: action.payload }
        case 'SET_EXTERNALRELEASE_ERROR':
            return { ...state, externalRelease: action.payload }
        case 'SET_COUNTRY_ERR':
            return { ...state, countryError: action.payload }
        case 'SET_PROVINCE_ERR':
            return { ...state, provinceError: action.payload }
        case 'SET_CITY_ERR':
            return { ...state, cityError: action.payload }
        case 'SET_ZIP':
            return { ...state, zip: action.payload }
        case 'SET_ZIP_ERR':
            return { ...state, zipError: action.payload }
        case 'SET_ERROR_REQUIERED_PROD':
            return { ...state, errorRequiredProd: action.payload }
        case 'SET_IMAGE_UPLOAD_ERROR':
            return { ...state, imageUploadError: action.payload }
        case 'SET_FOE_ERR':
            return { ...state, foeError: action.payload }
        case 'SET_TITLE_ERR':
            return { ...state, titleError: action.payload }
        case 'SET_TO_CONTEST':
                return { ...state, contestRelease: action.payload }
        case 'SET_LAT':
                return  {...state, latitude: action.payload} 
        case 'SET_LONG':
                return  {...state, longitude: action.payload}  
        case 'SET_SOURCE':
                return  {...state, source: action.payload}
        case 'SET_UPLOAD_READY':
                return  {...state, uploadReady: action.payload}
        default:
            return state;
    }

}